import React from 'react'

const ProjectActionsDisabled = ({ max_actions_per_month }) => {
  return (
    <div class="alert alert-warning shadow-lg max-w-md">
      <div>
        <div>
          <h3 class="font-bold">Usage Limit Reached</h3>
          <p class="text-sm">
            You've reached this month's limit
            of <strong>{max_actions_per_month}</strong> actions.
            Please upgrade to continue, or wait for next month.
          </p>
        </div>
      </div>
    </div>
  )
}

export default ProjectActionsDisabled